import React from 'react';
import { BeginUnsubscribe as BeginUnsubscribeScreen } from '@features/begin-unsubscribe';

export const BeginUnsubscribe = (props: any) => <BeginUnsubscribeScreen {...props} />;
